// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"styles__parentContainer___8elzb","childContainer":"styles__childContainer___h6-f6","blue":"styles__blue___3ObFa"};